import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { OccEndpointsService, TranslationService } from '@spartacus/core';
import { BehaviorSubject, Observable, forkJoin } from 'rxjs';
import { payloadEnda } from '../../sapSpartacus/model.model';
import { AirdiskTooltipPopUpComponent } from 'src/app/customcomponents/AirDisk-brake/airdisk-tooltip-pop-up/airdisk-tooltip-pop-up.component';

@Injectable({
  providedIn: 'root'
})
export class AirdiskbrakeService {

  public defaultvistInfo = {
    firstName: '',
    lastName: '',
    eMail: '',
    adbValueCalculatorType: '',
    valueDisclaimer: false
  };

  private defaultFleetInfo = {
    fleetSize : 1000,
    totalNumberOfAxlesPerUnit : 3,
    tractorTradeInCycle : 5,
    trailerTradeInCycle : 10,
    averageAnnualUnitMilage : 100000,
    drumToShoeReplacementFrequency : 1,
    adbUpCharge : 2500.00,
    fleetMaintenanceLaborRate : 130.00,
    adbResidualValueAtTradeIn : 500.00,
    fleetDownTimeRate : 1050.00,
  };

  public defaultFleetSafety = {
    annualFleetAccidentRate : 10,
    noOfRearEndCollisionsDuringLifecycle : 114,
    rearEndCollisionUnitCost : 8584.31,
    lifecycleRearEndCollisionsFleetCost : 8584314,
  };

  public defaultFrictionDrumMaintainance = {
    averageMilageToChangeFriction : 400000,
    brakeFrictionRequirementAtTradeIn : 1,

    drumBreakShoeReplacementUnitCost : null,
    drumReplacementUnitCost : null,
    noOfFrictionReplacementsAtTradeIn : 1,
    noOfDrumReplacementsAtTradeIn : 1,
    drumBreakReplacementUnitCost : 1740.00,
    drumBreakReplacementFleetCost : 1740000.00,
  }

  public defaultDrumBrakeServiceCosts = {
    drumBreakServiceLabourCost : 0.17,
    totalDrumBreakServiceUnitCost : 2652.00,
    drumBreakServiceAnnualFrequency : 4,
    totalDrumBreakServiceFleetCost : 2652000
  }
  public defaultCSAViolation = {
    csaViolationsAnnualPercentage : 10,
    noOfCSAViolations : 100,
    roadSideCallRateForCSAViolations : 2000,
    annualnoOfOutOfServiceBreakCSAViolations : 13,
    csaUnitCost : 198.25,
    lifeCycleCSAFleetCost : 198250
  }
  public defaultRustJackingMaintainance = {
    drumBreakReplacementDueToRustJacking: 100,
    rustJackingShoeReplacementUnitCost: 219,
    rustJackingShoeReplacementFleetCost: 219000,
  }
  public defaultADBCostSummary = {
    adbImpactWithImprovedStoppingDistance: 1,
    initialADBFleetCost: 2500000,
    impactToFleetAccidentCosts: 150602,
    adbFrictionMileage: 600000,
    noOfPadReplacementsAtTradeIn: 1,
    noOfRotarReplacementsAtTradeIn: 0,
    padAndRotarReplacementUnitCost: 870,
    lifecyclePadAndRotarReplacementFleetCosts: 870000,
    adbBrakeAdjustmentMaintanaceFleetCost: 0,
    csaViolationFleetCost: 0,
    adbRustJackingPadReplacementFleetCost: 0,
    totalAdbUnitCost: 2719.40,
    totalADBFLeetCost: 2719398,
  }

  private popUpData=
  { FName: '', LName: '', emailId: '' };

  private defaultData = [
    {
        "drumUnit": 0,
        "drumFleet": 0,
        "ADBUnit": 2500,
        "ADBFleet": 2500000,
        "displayValue":"0.00_0_2500.00_2,500,000"
    },
    {
        "drumUnit": 0,
        "drumFleet": 0,
        "ADBUnit": 500,
        "ADBFleet": 500000,
        "displayValue":"0.00_0_500.00_500,000"
    },
    {
        "drumUnit": 0,
        "drumFleet": 0,
        "ADBUnit": 150.60,
        "ADBFleet": 150602,
        "displayValue":"0.00_0_150.60_150,602"
    },
    {
        "drumUnit": 1740,
        "drumFleet": 1740000,
        "ADBUnit": 870,
        "ADBFleet": 870000,
        "displayValue": "1740.00_1,740,000_870.00_870,000"
    },
    {
        "drumUnit": 2652,
        "drumFleet": 2652000,
        "ADBUnit": 0,
        "ADBFleet": 0,
        "displayValue": "2652.00_2,652,000_0.00_0"
    },
    {
        "drumUnit": 198.25,
        "drumFleet": 198250,
        "ADBUnit": 0,
        "ADBFleet": 0,
        "displayValue": "198.25_198,250_0.00_0"
    },
    {
        "drumUnit": 219,
        "drumFleet": 219000,
        "ADBUnit": 0,
        "ADBFleet": 0,
        "displayValue": "219.00_219,000_0.00_0"
    },
    {
        "drumUnit": 4809.25,
        "drumFleet": 4809250,
        "ADBUnit": 2719.40,
        "ADBFleet": 2719398,
        "displayValue": "4809.25_4,809,250_2719.40_2,719,398"
    },
    {
      "roiOverLifeCycle_USD_UNIT": 2089.85,
      "roiOverLifeCycle_USD":2089852,
      "displayValue": "2089.85_2,089,852"
  }
]

  private selectedOptionSubject = new BehaviorSubject<string>(null);
  selectedOption$ = this.selectedOptionSubject.asObservable();
  setSelectedOption(option: string) {
    this.selectedOptionSubject.next(option);
  }

  getSelectedOption(): string {
    return this.selectedOptionSubject.getValue();
  }

  toolTipData$ =  new BehaviorSubject<any[]>([]);
  currentComponent$=new BehaviorSubject<any>(null);
  valueDisclaimer$=new BehaviorSubject<any>(false);

  vistInfoData$=new BehaviorSubject<any>(this.defaultvistInfo);
  fleetInfoData$=new BehaviorSubject<any>(this.defaultFleetInfo);
  fleetSafetyData$=new BehaviorSubject<any>(this.defaultFleetSafety);
  frictionDrumMaintainance$=new BehaviorSubject<any>(this.defaultFrictionDrumMaintainance);
  drumBrakeServiceCosts$=new BehaviorSubject<any>(this.defaultDrumBrakeServiceCosts);
  csaViolation$=new BehaviorSubject<any>(this.defaultCSAViolation);
  rustJackingMaintainance$=new BehaviorSubject<any>(this.defaultRustJackingMaintainance);
  adbCostSummary$=new BehaviorSubject<any>(this.defaultADBCostSummary);

  summaryData=new BehaviorSubject<any[]>(this.defaultData);
  summaryData$=this.summaryData.asObservable();
  popUpData$=new BehaviorSubject<any>(this.popUpData);

  resetForms$=new BehaviorSubject<any>(null);


   brandData = {
    "Bendix EnduraSure": 4.36,
    "Bendix EnduraSure-Pro": 8.00,
    "Haldex Gold Seal": 1.45,
    "Haldex Life Seal": 5.45,
    "TSE Omni": 2.55,
    "TSE Ultra": 3.49,
    "WABCO Tristop": 1.60,
    "Other": 1.45 // A default value if no match is found
  }
  netSavingText: any;
  payload: any;

  // airdisc
  E13 : any;
  E14 : any;
  E15 : any;
  E16 : any;
  E17 : any;
  E18 : any;
  E19 : any;
  E20 : any;
  E21 : any;
  E24 : any;
  E25 : any;
  E27 : any;
  E26 : any;
  E30 : any;
  E31: any;
  E32: any;
  E33: any;
  E34: any;
  E35: any;
  E36: any;
  E37: any;
  E40: any;
  E41: any;
  E42: any;
  E43: any;
  E46 : any;
  E47 : any;
  E48 : any;
  E49 : any;
  E51 : any;
  E50 : any;
  E54 : any;
  E55: any;
  E56: any;
  E60: any;
  E59: any;
  E63: any;
  E64: any;
  E66: any;
  E65: any;
  E67: any;
  E68: any;
  E69: any;
  E70: any;
  E71: any;
  E72: any;
  E73: any;
  E75 : any;
  E76 : any;
  I35: any;
  I34: any;
  I17: any;
  I67: any;
  I66: any;
  I112: any;
  C82 : any;
C83 : any;
C84 : any;
C85 : any;
C86 : any;
C87 : any;
C88 : any;
C89 : any;
B82 : any;
B83 : any;
B84 : any;
B85 : any;
B86 : any;
B87 : any;
B88 : any;
B89 : any;
E82 : any;
E83 : any;
F84 : any;
E84 : any;
E85 : any;
E86 : any;
E87 : any;
E88 : any;
E89 : any;
F82 : any;
F83 : any;
F85 : any;
F86 : any;
F87 : any;
F88 : any;
F89 : any;
E91 : any;
E92 : any;


res:Observable<any>;
  selectedValue: any;
  constructor(private matdialog: MatDialog,
    private http: HttpClient, private occService: OccEndpointsService,private translationService:TranslationService) {}

  // forToolTip
  openTootlip(tittle,content,content1?){
    this.toolTipData$.next([tittle,content,content1])
    this.matdialog.open(AirdiskTooltipPopUpComponent)
  }
  //GetAPI
  getbrandOfActuator(){
    return this.http.get(this.occService.buildUrl(`airDiscBrake/getdropdown`));
  }
TableCalculation(){

//Section I
this.I17=0;
this.I34=1;
this.I35=1;
this.I67=1;
this.I66=0;
this.I112=0;

this.selectedOption$.subscribe(option=>{
  if(option == null){
    this.selectedValue = 'Tractor';
  }else{
    this.selectedValue = option;
  }

})
this.fleetInfoData$?.subscribe(data=>{
  //Section 2
  this.E13 =data?.fleetSize;                       //E108
  this.E14 =data?.totalNumberOfAxlesPerUnit;       //E109
  this.E15 = (this.selectedValue == 'Tractor') ? (data?.tractorTradeInCycle) : (data?.trailerTradeInCycle);

  this.E16 =data?.averageAnnualUnitMilage;         //E111
  this.E17 =data?.drumToShoeReplacementFrequency;  //E112
  this.E18 =data?.adbUpCharge;                     //E113
  this.E19 = data?.adbResidualValueAtTradeIn;      //E114
  this.E20 =data?.fleetMaintenanceLaborRate;       //E115
  this.E21 = data?.fleetDownTimeRate;              //E116
});

this.fleetSafetyData$?.subscribe(data=>{
//Section 3
  this.E24 = data?.annualFleetAccidentRate;                     //E118
 
  this.E25 = data?.noOfRearEndCollisionsDuringLifecycle;
  this.E27 = data?.rearEndCollisionUnitCost;
  this.E26 = data?.lifecycleRearEndCollisionsFleetCost;

});

this.frictionDrumMaintainance$?.subscribe(data=>{
//Section 4
  this.E30 = data?.averageMilageToChangeFriction;
  this.E31 = data?.brakeFrictionRequirementAtTradeIn;
  this.E32 = data?.drumBreakShoeReplacementUnitCost;
  this.E33 = data?.drumReplacementUnitCost;
  this.E34 = data?.noOfFrictionReplacementsAtTradeIn;
  this.E35 = data?.noOfDrumReplacementsAtTradeIn;
  this.E36 = data?.drumBreakReplacementUnitCost;
  this.E37 = data?.drumBreakReplacementFleetCost;

})

this.drumBrakeServiceCosts$?.subscribe(data=>{
  this.E40 = data?.drumBreakServiceLabourCost;
  this.E41 = data?.drumBreakServiceAnnualFrequency;
  this.E42 = data?.totalDrumBreakServiceUnitCost;
  this.E43 = data?.totalDrumBreakServiceFleetCost;

});

this.csaViolation$?.subscribe(data=>{
  //Section 6
  this.E46 = data?.csaViolationsAnnualPercentage;
  this.E47 = data?.roadSideCallRateForCSAViolations;
  this.E48 = data?.noOfCSAViolations;
  this.E49 = data?.annualnoOfOutOfServiceBreakCSAViolations;
  this.E50 = data?.csaUnitCost;
  this.E51 = data?.lifeCycleCSAFleetCost;

})
this.rustJackingMaintainance$?.subscribe(data=>{
  //section 7
  this.E54 = data?.drumBreakReplacementDueToRustJacking;
  this.E55 = data?.rustJackingShoeReplacementUnitCost;
  this.E56 = data?.rustJackingShoeReplacementFleetCost;

})


  this.adbCostSummary$?.subscribe(data => {
    //   //Section 8
    this.E60 = this.E37 + this.E43 + this.E51 + this.E56 ;
    this.E59 = this.E60 / this.E13 ;
    //Section 9
    this.E63 = data?.adbImpactWithImprovedStoppingDistance / 100; //E158 //parseFloat(($('.adbImpactWithImprovedStoppingDistance').val()) / 100);
    this.E64 = this.E18 * this.E13;    											      //E159
    this.E66 = this.E30 * 1.5;      														  //E161
    this.E71 = 0;     																            //E166
    this.E72 = 0;     																            //E167
    this.E73 = 0;																                	//E168

    if (this.selectedValue == 'Tractor') {
      this.E65 = (Math.ceil(this.E25 * this.E63) * 75301);      	//E160
      this.E67 = (this.E31 === 1) ? this.I67 : this.I66;      		//E162
      this.E68 = (this.E67 > 1) ? (this.E67 / 2) : 0;      				//E163
      this.E69 = this.E67 * ((225 * this.E14) + (this.E14 * 2 * 0.25 * this.E20)) + this.E68 * ((375 * this.E14 * 2) + (this.E14 * 2 * 2 * this.E20));  //E164    															//E158
      this.E70 = this.E69 * this.E13;  													//E165

    }
    else {
      this.E65 = (Math.ceil(this.E27 * this.E63) * 63000);      											//E160
      this.E67 = Math.floor(this.E16 * this.E15 / this.E66);      										//E162
      this.E68 = (this.E67 > 1) ? Math.floor(this.E67 / 2) : 0      									//E163
      this.E69 = this.E67 * ((225 * this.E14) + (this.E14 * 2 * 0.25 * this.E20)) + this.E68 * ((375 * this.E14 * 2) + (this.E14 * 2 * 2 * this.E20)); //E164    															//E158
      this.E70 = this.E69 * this.E13;      													                  //E165

    }

    //
    this.E63 = data?.adbImpactWithImprovedStoppingDistance;
    this.E64 = data?.initialADBFleetCost;
    this.E65 = data?.impactToFleetAccidentCosts;
    this.E66 = data?.adbFrictionMileage;
    this.E67 = data?.noOfPadReplacementsAtTradeIn;
    this.E68 = data?.noOfRotarReplacementsAtTradeIn;
    this.E69 = data?.padAndRotarReplacementUnitCost;
    this.E70 = data?.lifecyclePadAndRotarReplacementFleetCosts;
    this.E71 = data?.adbBrakeAdjustmentMaintanaceFleetCost;
    this.E72 = data?.csaViolationFleetCost;
    this.E73 = data?.adbRustJackingPadReplacementFleetCost;
    this.E75 = data?.totalAdbUnitCost;
    this.E76 = data?.totalADBFLeetCost;


  });


//Table Calculation

//Column1

this.B82=0;
this.B83=0;
this.B84=0;
this.B85=this.E36;
this.B86=this.E42;
this.B87=this.E50;
this.B88=this.E55;
this.B89=this.B82 + this.B83 + this.B84 + this.B85 + this.B86 + this.B87 + this.B88;

 //alert("Col-1: "+B82+" , "+B83+" , "+B84+" , "+B85+" , "+B86+" , "+B87+" , "+B88+" , "+B89);

//Column2
this.C82 = 0;
this.C83 = 0;
this.C84 = 0;
this.C85 = this.E37;
this.C86 = this.E43;
this.C87 = this.E51;
this.C88 = this.E56;
this.C89 =this.C82 + this.C83 + this.C84 + this.C85 + this.C86 + this.C87 + this.C88;

 //alert("Col-2: "+C82+","+C83+" , "+C84+" , "+C85+" , "+C86+" , "+C87+" , "+C88+" , "+C89);

//Column3
this.E82 = this.E18;
this.E83 = this.E19;
this.F84 = this.E65;
this.E84 = this.F84/this.E13;
this.E85 = this.E69;
this.E86 = this.E71;
this.E87 = this.E72;
this.E88 = this.E73;
this.E89 =this.E82-this.E83-this.E84+this.E85+this.E86+this.E87+this.E88;
//alert("Col-3: "+E82+","+E83+" , "+E84+" , "+E85+" , "+E86+" , "+E87+" , "+E88+" , "+E89);

//Column4
this.F82 = this.E64;
this.F83 = this.E83*this.E13;
this.F84 = this.E65;
this.F85 = this.E70;
this.F86 = this.E86*this.E13;
this.F87 = this.E87*this.E13;
this.F88 = this.E88*this.E13;
this.F89 = this.F82-this.F83-this.F84+this.F85+this.F86+this.F87+this.F88;

//Roi Table

this.E91= this.B89-this.E89;
this.E92= this.C89-this.F89;

// Text Population on HTML

//Row-1
const row1 = this.createRowData( this.B82, this.C82, this.E82, this.F82);
this.updateRow(0, row1);

//Row-2
const row2 = this.createRowData( this.B83, this.C83, this.E83, this.F83);
this.updateRow(1, row2);

//Row-3
const row3 = this.createRowData( this.B84, this.C84, this.E84, this.F84);
this.updateRow(2, row3);

//Row-4
const row4 = this.createRowData( this.B85, this.C85, this.E85, this.F85);
this.updateRow(3, row4);

//Row-5
const row5 = this.createRowData( this.B86, this.C86, this.E86, this.F86);
this.updateRow(4, row5);

//Row-6
const row6 = this.createRowData( this.B87, this.C87, this.E87, this.F87);
this.updateRow(5, row6);

//Row-7
const row7 = this.createRowData( this.B88, this.C88, this.E88, this.F88);
this.updateRow(6, row7);

//Row-8
const row8 = this.createRowData( this.B89, this.C89, this.E89, this.F89);
this.updateRow(7, row8);

  //ROI Table

  
   this.translationService.translate('common.airdiscBrake_value_calculator_negative_roi').subscribe(x=>{
    this.netSavingText=x;
 });
   const row9 = this.createRoiRowData(this.E91, this.E92);
   this.updateRow(8, row9);
}


createRowData(drumUnit: number, drumFleet: number, ADBUnit: any, ADBFleet: number) {
  const displayValue = `${drumUnit.toFixed(2)}_${Math.round(drumFleet).toLocaleString('en-US', { style: 'decimal', maximumFractionDigits: 0 })}_${ADBUnit.toFixed(2)}_${Math.round(ADBFleet).toLocaleString('en-US', { style: 'decimal', maximumFractionDigits: 0 })}`;
  return {
    drumUnit,
    drumFleet,
    ADBUnit,
    ADBFleet,
    displayValue
  };
}

createRoiRowData(roiOverLifeCycle_USD_UNIT: number, roiOverLifeCycle_USD: any) {
  const displayValue = `${roiOverLifeCycle_USD_UNIT.toFixed(2)}_${Math.round(roiOverLifeCycle_USD).toLocaleString('en-US', { style: 'decimal', maximumFractionDigits: 0 })}}`;
  return {
    roiOverLifeCycle_USD_UNIT,
    roiOverLifeCycle_USD,
    displayValue
  };
}

updateRow(index, rowData): void {

    const currentData = this.summaryData.value;
    if (index >= 0&& index < currentData.length) {
      currentData[index] = rowData;
      this.summaryData.next([...currentData]);
    }

}

getCurrentData() {
  return this.summaryData.value;
}

triggerReset(){
  this.vistInfoData$.next(this.defaultvistInfo);
  this.fleetInfoData$.next(this.defaultFleetInfo);
  this.fleetSafetyData$.next(this.defaultFleetSafety);
  this.frictionDrumMaintainance$.next(this.defaultFrictionDrumMaintainance);

  this.drumBrakeServiceCosts$.next(this.defaultDrumBrakeServiceCosts);
  this.csaViolation$.next(this.defaultCSAViolation);
  this.rustJackingMaintainance$.next(this.defaultRustJackingMaintainance);
  this.adbCostSummary$.next(this.defaultADBCostSummary);

  this.summaryData.next(this.defaultData);
}

postAPI(){
  return this.http.post(this.occService.buildUrl('airDiscBrake/sentemail'),this.createPayload(),{ responseType: 'text' });
}
  createPayload() {
    this.payload = {
      eMail: '',
      firstName: '',
      lastName: '',
      valueDisclaimer: '',
      adbValueCalculatorType: '',

      fleetSize: '',
      totalNumberOfAxlesPerUnit: '',
      tractorTradeInCycle: '',
      trailerTradeInCycle: '',
      averageAnnualUnitMilage: '',
      drumToShoeReplacementFrequency: '',
      adbUpCharge: '',
      fleetMaintenanceLaborRate: '',
      adbResidualValueAtTradeIn: '',
      fleetDownTimeRate: '',

      annualFleetAccidentRate: '',
      noOfRearEndCollisionsDuringLifecycle: '',
      rearEndCollisionUnitCost: '',
      lifecycleRearEndCollisionsFleetCost: '',


      averageMilageToChangeFriction: '',
      noOfFrictionReplacementsAtTradeIn: '',
      drumBreakShoeReplacementUnitCost: '',
      noOfDrumReplacementsAtTradeIn: '',
      drumReplacementUnitCost: '',
      drumBreakReplacementUnitCost: '',
      drumBreakReplacementFleetCost: '',
      brakeFrictionRequirementAtTradeIn: '',

      drumBreakServiceLabourCost: '',
      totalDrumBreakServiceUnitCost: '',
      drumBreakServiceAnnualFrequency: '',
      totalDrumBreakServiceFleetCost: '',

      csaViolationsAnnualPercentage: '',
      noOfCSAViolations: '',
      roadSideCallRateForCSAViolations: '',
      annualnoOfOutOfServiceBreakCSAViolations: '',
      csaUnitCost: '',
      lifeCycleCSAFleetCost: '',


      drumBreakReplacementDueToRustJacking: '',
      rustJackingShoeReplacementUnitCost: '',
      rustJackingShoeReplacementFleetCost: '',

      adbImpactWithImprovedStoppingDistance: '',
      initialADBFleetCost: '',
      impactToFleetAccidentCosts: '',
      adbFrictionMileage: '',
      noOfPadReplacementsAtTradeIn: '',
      noOfRotarReplacementsAtTradeIn: '',
      padAndRotarReplacementUnitCost: '',
      lifecyclePadAndRotarReplacementFleetCosts: '',
      adbBrakeAdjustmentMaintanaceFleetCost: '',
      csaViolationFleetCost: '',
      adbRustJackingPadReplacementFleetCost: '',
      totalAdbUnitCost: '',
      totalADBFLeetCost: '',


      displayValue1: '',
      displayValue2: '',
      displayValue3: '',
      displayValue4: '',
      displayValue5: '',
      displayValue6: '',
      displayValue7: '',
      total: '',
      roiOverLifeCycle_USD_UNIT: '',
      roiOverLifeCycle_USD: '',



      FName: '',
      LName: '',
      emailId: '',
    }

//9+1


  // defaultvistInfo
  this.vistInfoData$.subscribe((x:any) => {
    this.payload.eMail = x?.eMail ;
    this.payload.firstName = x?.firstName ;
    this.payload.lastName = x?.lastName ;
    this.payload.valueDisclaimer = x?.valueDisclaimer ;
    this.payload.adbValueCalculatorType = x?.adbValueCalculatorType ;
  });

  // defaultFleetInfo
  this.fleetInfoData$.subscribe((x:any) => {
    this.payload.fleetSize = x?.fleetSize;
    this.payload.totalNumberOfAxlesPerUnit = x?.totalNumberOfAxlesPerUnit;
    this.payload.tractorTradeInCycle = x?.tractorTradeInCycle;
    this.payload.trailerTradeInCycle = x?.trailerTradeInCycle;
    this.payload.averageAnnualUnitMilage = x?.averageAnnualUnitMilage;
    this.payload.drumToShoeReplacementFrequency = x?.drumToShoeReplacementFrequency;
    this.payload.adbUpCharge = x?.adbUpCharge;
    this.payload.fleetMaintenanceLaborRate = x?.fleetMaintenanceLaborRate;
    this.payload.adbResidualValueAtTradeIn = x?.adbResidualValueAtTradeIn;
    this.payload.fleetDownTimeRate = x?.fleetDownTimeRate;
  });

  // defaultFleetSafety
  this.fleetSafetyData$.subscribe((x:any) => {
    this.payload.annualFleetAccidentRate = x?.annualFleetAccidentRate ;
    this.payload.noOfRearEndCollisionsDuringLifecycle = x?.noOfRearEndCollisionsDuringLifecycle ;
    this.payload.rearEndCollisionUnitCost = x?.rearEndCollisionUnitCost ;
    this.payload.lifecycleRearEndCollisionsFleetCost = x?.lifecycleRearEndCollisionsFleetCost ;
  });

    // defaultFrictionDrumMaintainance
    this.frictionDrumMaintainance$.subscribe((x:any) => {
      this.payload.averageMilageToChangeFriction = x?.averageMilageToChangeFriction;
      this.payload.noOfFrictionReplacementsAtTradeIn = x?.noOfFrictionReplacementsAtTradeIn;
      this.payload.brakeFrictionRequirementAtTradeIn = x?.brakeFrictionRequirementAtTradeIn;
      this.payload.drumBreakShoeReplacementUnitCost = x?.drumBreakShoeReplacementUnitCost;
      this.payload.noOfDrumReplacementsAtTradeIn = x?.noOfDrumReplacementsAtTradeIn;
      this.payload.drumReplacementUnitCost = x?.drumReplacementUnitCost;
      this.payload.drumBreakReplacementUnitCost = x?.drumBreakReplacementUnitCost;
      this.payload.drumBreakReplacementFleetCost = x?.drumBreakReplacementFleetCost;
    });

  // defaultDrumBrakeServiceCosts
  this.drumBrakeServiceCosts$.subscribe((x:any) => {
    this.payload.drumBreakServiceLabourCost = x?.drumBreakServiceLabourCost ;
    this.payload.totalDrumBreakServiceUnitCost = x?.totalDrumBreakServiceUnitCost ;
    this.payload.drumBreakServiceAnnualFrequency = x?.drumBreakServiceAnnualFrequency ;
    this.payload.totalDrumBreakServiceFleetCost = x?.totalDrumBreakServiceFleetCost ;
  });

    // defaultCSAViolation pending
    this.csaViolation$.subscribe((x:any) => {
      this.payload.csaViolationsAnnualPercentage = x?.csaViolationsAnnualPercentage ;
      this.payload.noOfCSAViolations = x?.noOfCSAViolations ;
      this.payload.roadSideCallRateForCSAViolations = x?.roadSideCallRateForCSAViolations ;
      this.payload.annualnoOfOutOfServiceBreakCSAViolations = x?.annualnoOfOutOfServiceBreakCSAViolations ;
      this.payload.csaUnitCost = x?.csaUnitCost ;
      this.payload.lifeCycleCSAFleetCost = x?.lifeCycleCSAFleetCost ;
    });

  // defaultRustJackingMaintainance
  this.rustJackingMaintainance$.subscribe((x:any) => {
    this.payload.drumBreakReplacementDueToRustJacking = x?.drumBreakReplacementDueToRustJacking;
    this.payload.rustJackingShoeReplacementUnitCost = x?.rustJackingShoeReplacementUnitCost;
    this.payload.rustJackingShoeReplacementFleetCost = x?.rustJackingShoeReplacementFleetCost;
  });

  // defaultADBCostSummary
  this.adbCostSummary$.subscribe((x:any) => {
    this.payload.adbImpactWithImprovedStoppingDistance = x?.adbImpactWithImprovedStoppingDistance ;
    this.payload.initialADBFleetCost = x?.initialADBFleetCost ;
    this.payload.impactToFleetAccidentCosts = x?.impactToFleetAccidentCosts ;
    this.payload.adbFrictionMileage = x?.adbFrictionMileage ;
    this.payload.noOfPadReplacementsAtTradeIn = x?.noOfPadReplacementsAtTradeIn ;
    this.payload.noOfRotarReplacementsAtTradeIn = x?.noOfRotarReplacementsAtTradeIn ;
    this.payload.padAndRotarReplacementUnitCost = x?.padAndRotarReplacementUnitCost ;
    this.payload.lifecyclePadAndRotarReplacementFleetCosts = x?.lifecyclePadAndRotarReplacementFleetCosts ;
    this.payload.adbBrakeAdjustmentMaintanaceFleetCost = x?.adbBrakeAdjustmentMaintanaceFleetCost ;
    this.payload.csaViolationFleetCost = x?.csaViolationFleetCost ;
    this.payload.adbRustJackingPadReplacementFleetCost = x?.adbRustJackingPadReplacementFleetCost ;
    this.payload.totalAdbUnitCost = x?.totalAdbUnitCost ;
    this.payload.totalADBFLeetCost = x?.totalADBFLeetCost ;
  });

  this.summaryData$.subscribe((x:any) => {

    this.payload.displayValue1 = x[0]?.displayValue ;
    this.payload.displayValue2 = x[1]?.displayValue ;
    this.payload.displayValue3 = x[2]?.displayValue ;
    this.payload.displayValue4 = x[3]?.displayValue ;
    this.payload.displayValue5 = x[4]?.displayValue ;
    this.payload.displayValue6 = x[5]?.displayValue ;
    this.payload.displayValue7 = x[6]?.displayValue ;
    this.payload.displayValue8 = x[7]?.displayValue ;

    this.payload.roiOverLifeCycle_USD_UNIT= x[8]?.roiOverLifeCycle_USD_UNIT;
    this.payload.roiOverLifeCycle_USD=x[8]?.roiOverLifeCycle_USD ;
  });

  this.popUpData$.subscribe((x:any) => {

    this.payload.FName = x?.FName ;
    this.payload.LName = x?.LName ;
    this.payload.emailId = x?.emailId ;
  });


  const payload = {
    firstName: this.payload?.FName,
    lastName: this.payload?.LName,
    disclaimer: this.payload?.valueDisclaimer,
    adbValueCalculatorType: this.payload?.adbValueCalculatorType,
    companyEmail: this.payload?.emailId,

    fleetSize: this.payload?.fleetSize,
    totalNumberOfAxlesPerUnit: this.payload?.totalNumberOfAxlesPerUnit,
    tractorTradeInCycle: this.payload?.tractorTradeInCycle,
    trailerTradeInCycle: this.payload?.trailerTradeInCycle,
    averageAnnualUnitMilage: this.payload?.averageAnnualUnitMilage,
    drumToShoeReplacementFrequency: this.payload?.drumToShoeReplacementFrequency,
    adbUpCharge: this.payload?.adbUpCharge,
    fleetMaintenanceLaborRate: this.payload?.fleetMaintenanceLaborRate,
    adbResidualValueAtTradeIn: this.payload?.adbResidualValueAtTradeIn,
    fleetDownTimeRate: this.payload?.fleetDownTimeRate,

    annualFleetAccidentRate: this.payload?.  annualFleetAccidentRate,
    noOfRearEndCollisionsDuringLifecycle: this.payload?.  noOfRearEndCollisionsDuringLifecycle,
    rearEndCollisionUnitCost: this.payload?.  rearEndCollisionUnitCost,
    lifecycleRearEndCollisionsFleetCost: this.payload?.  lifecycleRearEndCollisionsFleetCost,


    averageMilageToChangeFriction: this.payload?.  averageMilageToChangeFriction,
    noOfFrictionReplacementsAtTradeIn: this.payload?.  noOfFrictionReplacementsAtTradeIn,
    drumBreakShoeReplacementUnitCost: this.payload?.  drumBreakShoeReplacementUnitCost,
    noOfDrumReplacementsAtTradeIn: this.payload?.noOfDrumReplacementsAtTradeIn,
    drumReplacementUnitCost: this.payload?.drumReplacementUnitCost,
    drumBreakReplacementUnitCost: this.payload?.drumBreakReplacementUnitCost,
    drumBreakReplacementFleetCost: this.payload?.drumBreakReplacementFleetCost,
    brakeFrictionRequirementAtTradeIn: this.payload?.brakeFrictionRequirementAtTradeIn,

    drumBreakServiceLabourCost: this.payload?.drumBreakServiceLabourCost,
    totalDrumBreakServiceUnitCost: this.payload?.totalDrumBreakServiceUnitCost,
    drumBreakServiceAnnualFrequency: this.payload?.drumBreakServiceAnnualFrequency,
    totalDrumBreakServiceFleetCost: this.payload?.totalDrumBreakServiceFleetCost,

    csaViolationsAnnualPercentage: this.payload?.csaViolationsAnnualPercentage,
    noOfCSAViolations: this.payload?.noOfCSAViolations,
    roadSideCallRateForCSAViolations: this.payload?.roadSideCallRateForCSAViolations,
    annualnoOfOutOfServiceBreakCSAViolations: this.payload?.annualnoOfOutOfServiceBreakCSAViolations,
    csaUnitCost: this.payload?.csaUnitCost,
    lifeCycleCSAFleetCost: this.payload?.lifeCycleCSAFleetCost,


    drumBreakReplacementDueToRustJacking: this.payload?.drumBreakReplacementDueToRustJacking,
    rustJackingShoeReplacementUnitCost: this.payload?.rustJackingShoeReplacementUnitCost,
    rustJackingShoeReplacementFleetCost: this.payload?.rustJackingShoeReplacementFleetCost,

    adbImpactWithImprovedStoppingDistance: this.payload?.adbImpactWithImprovedStoppingDistance,
    initialADBFleetCost: this.payload?.initialADBFleetCost,
    impactToFleetAccidentCosts: this.payload?.impactToFleetAccidentCosts,
    adbFrictionMileage: this.payload?.adbFrictionMileage,
    noOfPadReplacementsAtTradeIn: this.payload?.noOfPadReplacementsAtTradeIn,
    noOfRotarReplacementsAtTradeIn: this.payload?.noOfRotarReplacementsAtTradeIn,
    padAndRotarReplacementUnitCost: this.payload?.padAndRotarReplacementUnitCost,
    lifecyclePadAndRotarReplacementFleetCosts: this.payload?.lifecyclePadAndRotarReplacementFleetCosts,
    adbBrakeAdjustmentMaintanaceFleetCost: this.payload?.adbBrakeAdjustmentMaintanaceFleetCost,
    csaViolationFleetCost: this.payload?.csaViolationFleetCost,
    adbRustJackingPadReplacementFleetCost: this.payload?.adbRustJackingPadReplacementFleetCost,
    totalAdbUnitCost: this.payload?.totalAdbUnitCost,
    totalADBFLeetCost: this.payload?.totalADBFLeetCost,


    initialPurchaseCost: this.payload?.displayValue1,
    residualValueAtTradeIn: this.payload?.displayValue2,
    estimatedImpactOfSaftey: this.payload?.displayValue3,
    estimatedReplacementMaintanaceCost: this.payload?.displayValue4,
    continuousMaintanaceCost: this.payload?.displayValue5,
    csaRelatedCosts: this.payload?.displayValue6,
    rustJackingCosts: this.payload?.displayValue7,
    total: this.payload?.displayValue8,

    roiOverLifeCycle_USD_UNIT: this.payload?.roiOverLifeCycle_USD_UNIT.toFixed(2),
    roiOverLifeCycle_USD: this.payload?.roiOverLifeCycle_USD.toLocaleString('en-US', { style: 'decimal', maximumFractionDigits: 0 }),

    FName: this.payload?.FName,
    LName: this.payload?.LName,
    emailId: this.payload?.emailId,
  }


return payload;
}

}
